export default class ScrollToTopController extends Classy {
  constructor() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    super();
    // The parent element
    this.parent = parent || document.body;
    // whether or not the button is visible
    this.visible = false;
    // The threshold for a long page
    this.threshold = 3;
    // Create a new button
    this.button = document.createElement('button');
    // Create a new top indicator
    this.indicator = document.createElement('div');
    // Create a resize observer to watch for long pages
    this.ResizeObserver = new ResizeObserver(() => this.update());
    // Create an intersection observer to watch for the top of the page
    this.IntersectionObserver = new IntersectionObserver(entries => {
      this.button.classList.toggle('visible', !entries[0].isIntersecting);
    });

    // Observer the body for changes
    this.ResizeObserver.observe(this.parent);

    // Observe the indicator for changes
    this.IntersectionObserver.observe(this.indicator);

    // Set the button text
    this.button.innerText = 'Back to Top';
    // Set the button class
    this.button.classList.add('scroll-to-top');
    // Set the indicator class
    this.indicator.classList.add('page-top-indicator');

    // Add a click event listener
    this.button.addEventListener('click', e => {
      e.preventDefault();
      this.click();
    });

    // Append the indicator to the body, before the first child
    this.parent.insertBefore(this.indicator, this.parent.firstChild);
  }
  update() {
    if (this.parent.clientHeight > window.innerHeight * this.threshold) {
      // If the button is already visible, don't do anything
      if (this.visible) return;
      // Set the button to visible
      this.visible = true;
      // Add the button to the body
      document.body.appendChild(this.button);
    } else {
      // If the button is not visible, don't do anything
      if (!this.visible) return;
      // Set the button to not visible
      this.visible = false;
      // Remove the button from the body
      document.body.removeChild(this.button);
    }
    this.callback('update', this.visible);
  }
  click() {
    this.callback('click');
  }
}